import React from "react";
import { Link } from "react-router-dom";
import { getPageAiContent } from "../../utils/pageAiContent";
import "../../styles/page-ai-section.css";

/**
 * Contextual AI block: what Jstechno does with AI for this page/topic.
 */
export default function PageAISection({
  title,
  variant = "default",
  group,
  slug,
  hubKey,
  className = "",
}) {
  const content = getPageAiContent({ title, variant, group, slug, hubKey });
  if (!content) return null;

  return (
    <section className={`jst-page-ai ${className}`.trim()} aria-labelledby="jst-page-ai-heading">
      <div className="container">
        <div className="jst-page-ai__card">
          <div className="jst-page-ai__badge" aria-hidden="true">
            AI
          </div>
          <div className="jst-page-ai__body">
            <h2 id="jst-page-ai-heading" className="jst-page-ai__title">
              {content.headline}
            </h2>
            <p className="jst-page-ai__lead">{content.lead}</p>
            <ul className="jst-page-ai__list">
              {content.capabilities.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <div className="jst-page-ai__actions">
              {content.ctaPrimary && (
                <Link to={content.ctaPrimaryPath || "/contact"} className="jst-btn jst-btn--primary">
                  {content.ctaPrimary}
                </Link>
              )}
              {content.ctaSecondary && (
                <Link
                  to={content.ctaSecondaryPath || "/resources/ai-automation-guides"}
                  className="jst-btn jst-btn--ghost-light"
                >
                  {content.ctaSecondary}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
